import {useState} from "react"
import {StepStatusType} from "@chakra-ui/react/"

export interface UseStepsProps {
    index?: number
    count: number
}

export type StepStatusTypeExt = StepStatusType | "error"

type StepState = {
    activeStep: number,
    stepStatusList: StepStatusTypeExt[]
}

export function useSteps(props: UseStepsProps) {
    const {index = 0, count} = props

    const [stepProps, setStepProps] = useState<StepState>({
        activeStep: index,
        stepStatusList: Array.from({length: count}, (v, i) => "incomplete") as StepStatusTypeExt[]
    })

    const maxStep = typeof count === "number" ? count - 1 : 0

    const isActiveStep = (step: number): boolean => step === stepProps.activeStep
    const isCompleteStep = (step: number): boolean => stepProps.stepStatusList[step] === "complete"

    const getStatus = (step: number): StepStatusTypeExt => {
        if (step === stepProps.activeStep) return "active"
        return stepProps.stepStatusList[step]
        // if (stepProps.completedSteps.includes(step)) return "complete"
        // return "incomplete"
    }

    const setStatus = (step: number, status: StepStatusTypeExt) => {

        setStepProps(props => {

            props.stepStatusList[step] = status

            return {
                ...props,
                stepStatusList: [...props.stepStatusList]
            }
        })

    }

    const goToStep = (step: number) => {
        setStepProps(props => (
            {
                ...props,
                activeStep: step
            }))
    }

    const goToNext = () => {
        setStepProps(props => (
            {
                ...props,
                activeStep: Math.min(maxStep, props.activeStep + 1)
            }))
    }

    const complete = () => {
        setStepProps(props => {

            props.stepStatusList[props.activeStep] = "complete"

            return {
                ...props,
                stepStatusList: [...props.stepStatusList]
            }
        })
    }

    const completeAndGoNext = () => {
        setStepProps(props => {
            props.stepStatusList[props.activeStep] = "complete"

            return {
                //completedSteps: [...props.completedSteps, props.activeStep],
                stepStatusList: [...props.stepStatusList],
                activeStep: Math.min(maxStep, props.activeStep + 1)
            }
        })
    }

    const goToPrevious = () => {
        setStepProps(props => (
            {
                ...props,
                activeStep: Math.max(0, props.activeStep - 1)
            }))
    }

    return {
        stepProps,
        setStepProps,
        isActiveStep,
        isCompleteStep,
        getStatus,
        setStatus,
        goToStep,
        complete,
        completeAndGoNext,
        goToNext,
        goToPrevious,
    }
}

export type UseStepsReturn = ReturnType<typeof useSteps>